<template>
  <div class="CallMe">
    <form action="" method="post">
      <input type="text" ref="name" placeholder="Ad Soyad">
      <input type="text" ref="subject" placeholder="Konu">
      <input type="text" ref="email" placeholder="E-Posta">
      <input type="text" ref="phone" placeholder="Telefon Numarasi">
      <textarea ref="message" rows="8" placeholder="Mesajınız"></textarea>
      <button @click.prevent="submitForm()" type="submit" name="button">
        GÖNDER
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'CallMe',
  methods: {
    submitForm() {
      this.$http.post('https://tus.la/tickets', {
        client: {
          email: this.$refs.name.value,
          phoneNumber: this.$refs.phone.value,
        },
        source: '/vestel',
        text: this.$refs.text.value,
        _callCenter: '56bc4657a34c6c283780bd16',
      }).then(() => {
        this.$router.push({ name: 'Success' });
      })
      .catch(console.log);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .CallMe {

    input,
    textarea {
      color: #858484;
      padding: 10px 15px;
      width: 80%;
      margin: 5px auto;
      border: 1px solid #E0E0E0;
      border-radius: 5px;
      font-size: 13px;
      font-weight: 300;
      resize: none;

      &:focus {
        outline: 0;
      }
    }

    button {
      background: #2B7EED;
      border: 0;
      color: #fff;
      display: block;
      width: 90%;
      margin: 0 auto;
      padding: 15px;
      font-size: 15px;
      font-weight: 300;
      border-radius: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// CallMe.vue?e4e6c972